module.exports = __webpack_public_path__ + "img/6_17.2f7667c8.png";